import { FC, memo, useEffect, useState } from 'react'
import Link from 'next/link'
import NavbarRoot from './NavbarRoot'
import Container from '@components/ui/Container/Container'
// import { TopNavLinks } from '@components/yadav/ui'
import dynamic from 'next/dynamic'
import { useBreakpoints } from 'hooks/useTailwindBreakpoints'

const MobileNav = dynamic(
  () => import('@components/yadav/common/MobileNav/MobileNav'),{
    ssr: false
  }
)
const DesktopNav = dynamic(
  () => import('@components/yadav/common/DesktopNav/DesktopNav'),
  {
    ssr: false
  }
)

const TopNavLinks = dynamic(
  () => import('@components/yadav/ui/TopNavLinks'),
)

interface Link {
  href: string
  label: string
}

interface NavbarProps {
  links?: Link[]
}

const Navbar: FC<NavbarProps> = ({ links }) => {
  const bp = useBreakpoints()
  const isMdUp = !!bp.md
  
  const [mounted, setMounted] = useState(false)
  useEffect(() => { setMounted(true) }, [])
  
  return (
    <NavbarRoot>
      <TopNavLinks />
      <Container excludePaddingX>
        { !mounted ? ( <div className="w-full h-[132px] md:h-[220px]" aria-hidden /> )
                   : (isMdUp ? <DesktopNav /> : <MobileNav />)
        }
      </Container>
    </NavbarRoot>
  )
}

export default memo(Navbar)
